<template>
  <div class="fc-button">
    <span>{{this.text}}</span>
    <img class="mobile-arrow" src="@/assets/mobile-nav-arrow.svg" />
  </div>
</template>

<script>
export default {
  props: {
    text: String
  }
};
</script>

<style lang="scss" scoped>
.fc-button {
  cursor: pointer;
  position: relative;
  background: rgba($primary-color, 0.8);
  transition: all 1s cubic-bezier(0.165, 0.84, 0.44, 1);
  border: 3px solid #ffffff;
  box-shadow: 0px 0px 15px $primary-color;
  min-width: 355px;
  box-sizing: border-box;
  padding: 20px 25px;
  height: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    white-space: nowrap;
    transition: color 1s cubic-bezier(0.165, 0.84, 0.44, 1);
    font-size: 24px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    text-transform: uppercase;
  }
  .mobile-arrow {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
  }
}
@media (min-width: 999px) {
  .mobile-arrow {
    display: none;
  }
}
@media (max-width: 1000px) {
  .decoration {
    display: none;
  }
  .fc-button {
    border-bottom: 1px solid #fff;
    display: block;
    height: auto;
    text-align: left;
    padding: 5px 15px;
    span {
      position: static;
      transform: none;
    }
  }
}
</style>